import React, { useMemo } from 'react';
import { STATUS_CONFIG } from 'screens/utils';
interface StatusCertificateCardData {
  status: any;
  apacuanaUser: any;
  history: any;
  cert: any;
  customer?: any;
  onOpenGenerateForm?: any;
  onOpenRevoqueForm?: any;
}

const StatusCertificateCard: React.FC<StatusCertificateCardData> = ({
  apacuanaUser,
  status,
  history,
  cert,
  customer,
  onOpenGenerateForm,
  onOpenRevoqueForm,
}) => {
  const { pendingDocuments, isFaceLivenessComplete } = useMemo(() => {
    const customerDocs = customer?.documents || [];

    const requiredDocs = cert?.documents || [];
    const uploadedDocIds = new Set(
      customerDocs
        .filter(
          (doc: any) =>
            !doc.faceliveness && doc.pref?.id && doc.status.id !== -1,
        )
        .map((doc: any) => doc.pref.id),
    );
    const pendingDocs = requiredDocs
      .filter((doc: any) => !doc.faceliveness)
      .filter(
        (doc: any) => !uploadedDocIds.has(doc.id) || doc.status.id === -1,
      );
    const isLivenessRequired = requiredDocs.some(
      (doc: any) => doc.faceliveness,
    );
    let livenessComplete = false;
    if (isLivenessRequired) {
      const unique = customerDocs.filter(
        (item: any, index: any, self: any) =>
          index === self.findIndex((t: any) => t.pref.id === item.pref.id),
      );

      livenessComplete = !unique.find(
        (doc: any) =>
          doc.faceliveness && (doc.status?.id === -1 || doc.id === null),
      );
    }
    if (!isLivenessRequired) {
      livenessComplete = true;
    }
    console.log({ livenessComplete });
    return {
      pendingDocuments: pendingDocs,
      isFaceLivenessComplete: livenessComplete,
    };
  }, [cert, customer]);

  return (
    <>
      {apacuanaUser?.apacuanaId ? (
        status &&
        status.text && (
          <div
            className="max-w-2xl mx-auto rounded-xl  overflow-hidden bg-white"
            style={{ width: '100%' }}
          >
            <div className="flex">
              <div
                className="w-4 flex-shrink-0 hidden md:block"
                style={{
                  backgroundColor:
                    pendingDocuments.length > 0 || !isFaceLivenessComplete
                      ? STATUS_CONFIG['En progreso'].background
                      : STATUS_CONFIG[status.text].background,
                }}
              ></div>

              <div className="flex-grow p-6 md:p-8">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-center">
                  <div className="flex justify-center md:col-span-1">
                    <div
                      className="p-3 rounded-full flex items-center justify-center"
                      style={{
                        marginTop: 24,
                        textAlign: 'center',
                        maxHeight: 200,
                        backgroundColor:
                          pendingDocuments.length > 0 || !isFaceLivenessComplete
                            ? STATUS_CONFIG['En progreso'].background
                            : STATUS_CONFIG[status.text].background,
                      }}
                    >
                      {status.text !== 'Verificado' ? (
                        React.cloneElement(
                          pendingDocuments.length > 0 || !isFaceLivenessComplete
                            ? STATUS_CONFIG['En progreso'].icon
                            : STATUS_CONFIG[status.text].icon,
                          {
                            style: {
                              color: STATUS_CONFIG[status.text].textColor,
                              strokeWidth: 2,
                              maxWidth: 100,
                            },
                          },
                        )
                      ) : (
                        <img
                          src={STATUS_CONFIG[status.text].icon}
                          style={{ maxWidth: 100 }}
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className="md:col-span-4 text-center md:text-left"
                    style={{ marginTop: 24 }}
                  >
                    <h2
                      className="text-xl md:text-2xl font-bold mb-1"
                      style={{
                        color:
                          pendingDocuments.length > 0 || !isFaceLivenessComplete
                            ? STATUS_CONFIG['En progreso'].textColor
                            : STATUS_CONFIG[status.text].textColor,
                      }}
                    >
                      {pendingDocuments.length > 0 || !isFaceLivenessComplete
                        ? 'En progreso'
                        : status.text}
                    </h2>
                    <p
                      className="text-base text-gray-600"
                      style={{ marginTop: 8 }}
                    >
                      {pendingDocuments.length > 0 || !isFaceLivenessComplete
                        ? 'Tienes aun pasos que completar'
                        : status.text === 'Verificado'
                          ? '¡Listo! Su certificado digital ha sido generado y está activo. Ya puede utilizarlo para firmar documentos.'
                          : status.descriptionText}
                    </p>
                  </div>
                </div>
              </div>
              {(pendingDocuments.length > 0 || !isFaceLivenessComplete) && (
                <button
                  className={`btn btn-report ${'active'}`}
                  onClick={() => {
                    history.push({
                      pathname: `/apacuana/request/${
                        apacuanaUser?.apacuanaId || ''
                      }`,
                    });
                  }}
                >
                  <p>Continuar</p>
                </button>
              )}
              {status?.text === 'Por generar' && (
                <button
                  className={`btn btn-report ${'active'}`}
                  onClick={() => onOpenGenerateForm()}
                >
                  <p>Generar</p>
                </button>
              )}
              {(status?.text === 'Verificado' ||
                status?.text ===
                  'Certificado generado en otro dispositivo') && (
                <button
                  className={`btn btn-report ${'active'}`}
                  onClick={() => onOpenRevoqueForm()}
                >
                  <p>Solicitar revocación</p>
                </button>
              )}
            </div>
          </div>
        )
      ) : (
        <div className="max-w-2xl mx-auto rounded-xl  overflow-hidden bg-white">
          <div className="flex">
            <div
              className="w-4 flex-shrink-0 hidden md:block" // Oculto en móviles para un mejor layout
              style={{
                backgroundColor: STATUS_CONFIG['No Certificado'].background,
              }}
            ></div>

            <div className="flex-grow p-6 md:p-8">
              <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-center">
                <div className="flex justify-center md:col-span-1">
                  <div
                    className="p-3 rounded-full flex items-center justify-center"
                    style={{
                      marginTop: 24,
                      textAlign: 'center',
                      maxHeight: 200,
                      backgroundColor:
                        STATUS_CONFIG['No Certificado'].background,
                    }}
                  >
                    <img
                      src={STATUS_CONFIG['No Certificado'].icon}
                      style={{ maxWidth: 100 }}
                    />
                  </div>
                </div>
                <div
                  className="md:col-span-4 text-center md:text-left"
                  style={{ marginTop: 24 }}
                >
                  <h4
                    className="text-xl md:text-2xl font-bold mb-1"
                    style={{
                      color: STATUS_CONFIG['No Certificado'].textColor,
                    }}
                  >
                    No posee certificado electrónico.
                  </h4>
                  <p
                    className="text-base text-gray-600"
                    style={{ marginTop: 16 }}
                  >
                    Debe iniciar el proceso de solicitud para continuar.
                  </p>
                </div>
              </div>
              <button
                className={`btn btn-report ${'active'}`}
                onClick={() => {
                  history.push({
                    pathname: `/apacuana/request/${
                      apacuanaUser?.apacuanaId || ''
                    }`,
                  });
                }}
              >
                <p>Solicitar</p>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StatusCertificateCard;
